module.exports = __webpack_public_path__ + "static/VSLS-118c52a3bd66bc30bd67ae04ca147eaa.png";